import {createSlice} from "@reduxjs/toolkit";
import moment from "moment";
const loginTime = moment().utc().format()
const initialState = {
    isError: false,
    isSuccess: false,
    errorMessage: '',
    data: {},
    profileFlag: {},
    accountFlag: {},
    employerId: "",
    locationList: [],
    depsUnitsMaster:[],
    accountTypesMaster:[],
    trackingHistoryParams:{
        "appUserLoginHistoryId": 0,
        "userName": "",
        "memberType": 0,
        "appUserId": 0,
        "employerId": 0,
        "loginAttemptTime":loginTime,
        "loginResult": 0,
        "sourceIP": "string",
        "sourceAddress": "string",
        "sourceLocationCity": "string",
        "sourceState": "string",
        "sourceZip": "string",
        "sourceCountry": "string",
        "redirectPageUrl": "string",
        "browser": "string",
        "latitude": "string",
        "longitude": "string",
        "deviceType": "string",
        "deviceID": "string",
        "webAppVersion": 1,
        "mobileAppVersion": 0,
        "operatingSystem": "string"
      }
};

export const loginSlice = createSlice({
    name: 'login'
    , initialState,

    reducers: {
        loginRequest: (state) => {
            state.isError = false;
            state.isSuccess = false;
            state.errorMessage = '';
            data: {
            }
        },
        loginSuccess: (state, action) => {
            state.isError = false;
            state.isSuccess = true;
            state.errorMessage = '';
            state.data = action.payload;
            state.profileFlag = action.payload && action.payload.profileFlag;
            state.accountFlag = action.payload && action.payload.accountFlags;
            state.employerId = action.payload && action.payload.employerId;
        },
        setProfileFlag: (state, action) => {
            const flagName = action.payload;
            const newProfileFlag = {...state.profileFlag, [flagName]: true};
            state.profileFlag = newProfileFlag;
        },
        loginFailure: (state, action) => {
            state.isError = true;
            state.isSuccess = false;
            state.errorMessage = action.payload;
        },
        reset: state => {
            state.isError = false;
            state.isSuccess = false;
            state.errorMessage = '';
            state.data = {};
        },
        updateLocations: (state, action) => {
            state.locationList = action.payload;
        },
        updateMasterData:(state,{payload}) => {
            state[payload?.name] = payload?.value
          },
          updateBankAccountType:(state,{payload}) => {
            state.accountTypesMaster = payload;
          }
    }
});

export const {
    loginRequest,
    loginSuccess,
    loginFailure,
    setProfileFlag,
    reset,
    updateLocations,
    updateMasterData,
    updateBankAccountType
} = loginSlice.actions;

export default loginSlice.reducer;
